import BaseClass from "../BaseClass.js";

export default class TabHandler extends BaseClass {

    constructor(element) {
        super(element);

        this.tabs = null;
        this.tabSelectors = null;
        this.allowUrlChange = true;

        this.init();
    }

    init() {
        let mySelf = this;

        let allowUrlChange = this.$element.data('allow-url-change');
        if (allowUrlChange != undefined && !allowUrlChange) {
            this.allowUrlChange = false;
        }

        this.clickListener = function (event) {
            if (mySelf.allowUrlChange) {
                mySelf.changeTab(event);
            }
        }

        this.tabSelectors = this.$element.find('[data-type="nav-tab-selector"]');
        this.tabs = this.$element.find('[data-type="nav-tab"]');

        if (this.tabSelectors.length > 0 && this.tabs.length > 0) {
            this.tabSelectors.on("click", this.clickListener);
        }

        let hash = location.hash.replace(/^#/, '');
        if (hash && this.allowUrlChange == true) {
            this.autoActivateTabs(hash);
        }
    };

    changeTab(event) {
        window.location.hash = event.target.hash;
        $(document).scrollTop(0);
    }

    autoActivateTabs(hash) {
        let $selectedTabSelector = this.$element.find('[data-type="nav-tab-selector"][href="#' + hash + '"]');
        let $selectedTab = this.$element.find('[data-type="nav-tab"][id="' + hash + '"]');
        let currentActive = this.$element.find('[data-type="nav-tab-selector"].active').attr('href');
        let currentActiveTab = this.$element.find(currentActive);

        if ($selectedTabSelector.length > 0 && $selectedTab.length > 0) {
            this.tabSelectors.removeClass('active');
            this.tabs.removeClass('active');

            $selectedTabSelector.addClass('active');
            $selectedTab.addClass('active');

            if (currentActiveTab.length > 0
                && currentActive != '#' + hash) {
                currentActiveTab.removeClass('active show');
            }
            setTimeout(function () {
                $(document).scrollTop(0);
            }, 100);
        }
    }

    destroyListener() {
        if (this.tabSelectors.length > 0) {
            this.tabSelectors.off("click", this.clickListener);
        }
    }
}